// extracted by mini-css-extract-plugin
export default {"topMaxSize":"Top_topMaxSize__NNaFp"};